import type { ProductLogoSmallProps } from '../types';

export function ProductLogoSmallContracts({
  size = 20,
  color = '#0B1D12',
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M138.177 92.8116C156.922 74.0664 187.314 74.0664 206.059 92.8116L303.64 190.392C310.669 197.422 310.669 208.819 303.64 215.848C296.61 222.878 285.213 222.878 278.184 215.848L223.03 160.694C209.19 146.855 186.887 146.638 172.783 160.045L172.118 160.694L87.2651 245.547C77.8926 254.919 62.6966 254.919 53.324 245.547C34.5788 226.801 34.5788 196.41 53.324 177.664L138.177 92.8116Z"
        fill={color}
      />
      <path
        d="M180.603 186.15C189.976 176.777 205.172 176.777 214.544 186.15L265.456 237.061L266.121 237.71C280.225 251.117 302.528 250.901 316.368 237.061L324.853 228.576C338.912 214.517 338.912 191.723 324.853 177.664L273.941 126.753C264.569 117.38 264.569 102.184 273.941 92.8116C292.686 74.0666 323.078 74.0665 341.824 92.8116L426.676 177.664C445.421 196.41 445.421 226.801 426.676 245.547L252.728 419.495C245.699 426.524 234.302 426.524 227.272 419.495C220.243 412.465 220.243 401.069 227.272 394.039L299.397 321.914C304.083 317.228 304.083 309.63 299.397 304.944C294.711 300.257 287.113 300.257 282.427 304.944L210.302 377.069C203.272 384.098 191.875 384.098 184.846 377.069C177.816 370.039 177.816 358.642 184.846 351.613L256.971 279.488C261.657 274.802 261.657 267.204 256.971 262.517L256.749 262.301C252.048 257.832 244.613 257.904 240 262.517L167.875 334.642C160.846 341.672 149.449 341.672 142.419 334.642C135.39 327.613 135.39 316.216 142.419 309.186L214.544 237.061C219.231 232.375 219.231 224.777 214.544 220.091L214.323 219.875C209.696 215.477 202.422 215.477 197.795 219.875L197.574 220.091L125.449 292.216C118.419 299.245 107.022 299.245 99.993 292.216C92.9636 285.186 92.9636 273.789 99.993 266.76L180.603 186.15Z"
        fill={color}
      />
    </svg>
  );
}
